/* Core & libraries */
import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import UCButton from "../buttons";

/* Styles */
import styles from "./styles.js"
import generalStyles from "../../resources/styles/general"

const UCModal = props => {
  const {
    className,
    mainModalDivStyling,
    size,
    showModal,
    setShowModal,
    modalIcon,
    modalHeaderTitle,
    modalTitle,
    modalContent,
    modalDescription,
    modalFooter,
    dataTestId,
    onExited,
    keepOnBackdrop,
    hideCloseButton,
    customStyle,
    keyboard,
    modalHeaderSubtitle,
    backdropClassName,
  } = props;
  const theme = useTheme();
  const classes = styles({ theme });
  const generalClasses = generalStyles({ theme });

  return (
    <Modal
      size={size}
      dialogClassName={className}
      className={ mainModalDivStyling
        ? `${generalClasses.modal} ${mainModalDivStyling} ${generalClasses.formFields}`
        : `${generalClasses.modal} ${customStyle} ${generalClasses.formFields}`}
      show={showModal}
      onHide={() => setShowModal(false)}
      data-testid={dataTestId}
      onExited={onExited}
      keyboard={keyboard}
      backdrop={keepOnBackdrop ? "static" : true}
      backdropClassName={backdropClassName}
    >
      <Modal.Header closeButton={hideCloseButton ? false : true} className={classes.modalHeaderCustom} aria-labelledby={modalTitle ? "uc-modal-title" : "uc-header-title"}>
        {
          modalIcon &&
          <div className={classes.iconWrapper} id="iconWrapper">
            { modalIcon }
          </div>
        }
        {
          modalHeaderTitle &&
          <div className={classes.titleWrapper} id="uc-header-title">
            { modalHeaderTitle }
          </div>
        }
        {
          modalHeaderSubtitle &&
          <div className={classes.subtitleWrapper} id="uc-header-subtitle">
            { modalHeaderSubtitle }
          </div>
        }
      </Modal.Header>
      <Modal.Title className={classes.title} tabIndex={0} id="uc-modal-title">
        { modalTitle }
      </Modal.Title>
      <Modal.Body className={classes.body}>
        { modalDescription }
        { modalContent }
      </Modal.Body>
      {
        modalFooter &&
        <Modal.Footer className={classes.modalFooter}>
          { modalFooter }
        </Modal.Footer>
      }
    </Modal>
  )
}

export default UCModal;
